import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {SCOPE_TYPE} from "../../../@constants";
import {useRepricingFormData} from "../../@hooks";


const OPTIONS = [
	{ label: 'Include', value: SCOPE_TYPE.INCLUDE },
	{ label: 'Exclude', value: SCOPE_TYPE.EXCLUDE }
]

export default function RepricingFormScopeTypeSelect({ criterion, value }) {
	const { handleChangeScopeValue } = useRepricingFormData(criterion)

    return <SelectSeeker
		options={OPTIONS}
		value={value}
		onChange={e => handleChangeScopeValue('operation', e.target.value)}
	/>
}